import React, { useEffect, useState } from 'react';
import { motion } from 'framer-motion';
import { Zap, FileCheck, Infinity, ShieldCheck } from 'lucide-react';
function UrgencyCounter() {
  const [count, setCount] = useState(9);
  useEffect(() => {
    const decreaseCount = () => {
      setCount(prev => {
        if (prev <= 3) return prev;
        return prev - 1;
      });
      const nextInterval = Math.floor(Math.random() * (90000 - 45000 + 1)) + 45000;
      setTimeout(decreaseCount, nextInterval);
    };
    const timer = setTimeout(decreaseCount, Math.floor(Math.random() * 20000) + 10000);
    return () => clearTimeout(timer);
  }, []);
  return <div className="mt-4 flex flex-col items-center gap-1" data-id="element-211">
      <p className="text-red-500 font-bold text-lg animate-pulse" data-id="element-212">
        ⚠️ Últimos{' '}
        <motion.span key={count} initial={{
        scale: 1.4
      }} animate={{
        scale: 1
      }} className="inline-block text-2xl font-bebas" data-id="element-213">
          {count}
        </motion.span>{' '}
        mazos a este precio
      </p>
      <p className="text-white/50 text-sm" data-id="element-214">
        Después suben a{' '}
        <span className="text-white/70 font-semibold" data-id="element-215">$42.000 pesos</span>
      </p>
    </div>;
}
export function Pricing() {
  return <section className="py-10 px-4 bg-navy-800 relative" data-id="element-216">
      <div className="max-w-3xl mx-auto text-center" data-id="element-217">
        <motion.div initial={{
        opacity: 0,
        y: 30
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true,
        margin: '-100px'
      }} transition={{
        duration: 0.6
      }} className="bg-navy-900 rounded-3xl p-8 md:p-12 border border-white/10 shadow-2xl relative overflow-hidden" data-id="element-218">
          <div className="absolute top-0 left-0 w-full h-1 bg-gradient-to-r from-transparent via-gold to-transparent" data-id="element-219" />

          <p className="text-gold font-bebas text-2xl mb-2 tracking-widest" data-id="element-220">
            MAZO DE CARTAS ESPAÑOLAS +
          </p>
          <p className="text-gold font-bebas text-2xl mb-2 tracking-widest" data-id="element-221">
            MAZO DE "UNO" VERSIÓN SCALONETA
          </p>
          <p className="text-green-400 font-bebas text-xl mb-6 tracking-widest animate-pulse" data-id="element-222">
            + 2 BONOS GRATIS 🎁
          </p>

          <motion.div whileHover={{
          scale: 1.02
        }} whileTap={{
          scale: 0.98
        }} className="inline-block mb-8" data-id="element-223">
            <button className="group relative inline-flex items-center justify-center gap-3 px-8 md:px-12 py-5 bg-gold text-navy-900 font-bold text-xl md:text-2xl rounded-xl overflow-hidden shadow-[0_0_40px_rgba(212,175,55,0.3)] hover:shadow-[0_0_60px_rgba(212,175,55,0.5)] transition-shadow animate-[pulse_2s_ease-in-out_infinite]" data-id="element-224">
              <div className="absolute inset-0 bg-white/20 translate-y-full group-hover:translate-y-0 transition-transform duration-300 ease-out" data-id="element-225" />
              <span className="relative z-10" data-id="element-226">QUIERO MI EDICIÓN LIMITADA</span>
            </button>
          </motion.div>

          <div className="py-8 border-y border-white/5" data-id="element-227">
            <div className="flex items-center justify-center gap-3" data-id="element-228">
              <span className="text-7xl md:text-8xl font-bebas text-white drop-shadow-lg" data-id="element-229">
                $19.900
              </span>
              <span className="text-2xl font-bebas text-gold mt-4" data-id="element-230">pesos</span>
            </div>
            <UrgencyCounter data-id="element-231" />
          </div>

          {/* Payment methods */}
          <div className="mt-6 flex flex-col items-center gap-3" data-id="element-232">
            <div className="text-white/60 text-sm" data-id="element-233">Pagá con:</div>
            <div className="flex items-center justify-center gap-5" data-id="element-234">
              {/* VISA */}
              <div className="px-5 py-2.5 bg-[#142787] rounded-lg flex items-center justify-center" data-id="element-235">
                <span className="text-white font-bold italic text-lg tracking-wider" data-id="element-236">
                  VISA
                </span>
              </div>
              {/* Mastercard */}
              <div className="px-5 py-2.5 bg-navy-800 border border-white/10 rounded-lg flex items-center justify-center" data-id="element-237">
                <div className="w-6 h-6 rounded-full bg-[#EB001B] opacity-90 z-10 translate-x-1.5" data-id="element-238"></div>
                <div className="w-6 h-6 rounded-full bg-[#F79E1B] opacity-90 -translate-x-1.5" data-id="element-239"></div>
              </div>
              {/* Mercado Pago */}
              <div className="px-2 py-1 bg-white rounded-lg flex items-center justify-center" data-id="element-240">
                <img src="https://cdn.magicpatterns.com/uploads/iWmpLkgUmC8xuDezegJkdt/images.jpg" alt="Mercado Pago" className="h-9 w-auto object-contain" data-id="element-241" />
              </div>
            </div>
          </div>

          <div className="flex flex-wrap items-center justify-center gap-3 mt-8" data-id="element-242">
            <div className="flex items-center gap-2 px-3 py-1.5 rounded-full bg-navy-800 border border-gold/30 text-sm text-white/80" data-id="element-243">
              <Zap className="w-4 h-4 text-gold" data-id="element-244" />
              <span data-id="element-245">Descarga inmediata</span>
            </div>
            <div className="flex items-center gap-2 px-3 py-1.5 rounded-full bg-navy-800 border border-gold/30 text-sm text-white/80" data-id="element-246">
              <FileCheck className="w-4 h-4 text-gold" data-id="element-247" />
              <span data-id="element-248">Archivo digital de alta resolución</span>
            </div>
            <div className="flex items-center gap-2 px-3 py-1.5 rounded-full bg-navy-800 border border-gold/30 text-sm text-white/80" data-id="element-249">
              <Infinity className="w-4 h-4 text-gold" data-id="element-250" />
              <span data-id="element-251">Acceso de por vida</span>
            </div>
            <div className="flex items-center gap-2 px-3 py-1.5 rounded-full bg-navy-800 border border-gold/30 text-sm text-white/80" data-id="element-252">
              <ShieldCheck className="w-4 h-4 text-gold" data-id="element-253" />
              <span data-id="element-254">Único pago, sin mensualidades</span>
            </div>
          </div>
        </motion.div>
      </div>
    </section>;
}